import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

const VARIANT_CLS = {
  blue:    'bg-naia-info-bg text-naia-blue',
  green:   'bg-naia-green-bg text-naia-green',
  neutral: 'bg-naia-card-alt text-muted-foreground',
  purple:  'bg-naia-purple-bg text-naia-purple',
  orange:  'bg-[var(--naia-orange-bg)] text-naia-orange',
} as const

const SIZE_CLS = {
  sm: 'size-[38px] rounded-[10px]',
  md: 'size-10 rounded-[11px]',
  lg: 'size-12 rounded-[12px]',
} as const

export type IconPadVariant = keyof typeof VARIANT_CLS
export type IconPadSize = keyof typeof SIZE_CLS

export function IconPad({
  variant = 'blue',
  size = 'lg',
  className,
  children,
}: {
  variant?: IconPadVariant
  size?: IconPadSize
  className?: string
  children: ReactNode
}) {
  return (
    <span className={cn(
      'inline-flex shrink-0 items-center justify-center',
      VARIANT_CLS[variant],
      SIZE_CLS[size],
      className,
    )}>
      {children}
    </span>
  )
}
